import React, { useEffect, useMemo, useRef, useState } from "react";
import { MapComponent } from "./MapComponent";
import { isNotNullOrUndefined } from "../../../_metronic/_helpers/isNotNull";
import useDebounce from "../../../hooks/useDebounceHook";
import { ApiGet, ApiPost } from "../../../helpers/API/ApiData";
import Select from "react-select";
import { toast } from "react-toastify";
import { ProjectStyle } from "./constants";
import GoogleAutocomplete from "./googleAutocomplete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./map.scss";
import useIsMobile from "../../_helpers/useMobileView";
import { forEach } from "lodash";

const GoogleMap = () => {
  const center = { lat: 51.03447636760166, lng: 11.8386485625 };

  const [searchValue, setSearchValue] = useState("");
  const [LeadSources, setLeadSources] = useState();
  const [bounds, setBounds] = useState();
  const [leadsData, setLeadsData] = useState([]);
  const [zoom, setZoom] = useState(6.25);
  const [openMarker, setOpenMarker] = useState(null);
  const [leadStatus, setLeadStatus] = useState([]);
  const [AllUser, setAllUser] = useState([]);
  const [Users, setUsers] = useState([]);
  const [searchLat, setSearchLat] = useState({ lat: "", lng: "" });
  const [map, setMap] = useState(null);
  const searchDebaounce = useDebounce(searchValue, 400);
  const [assignOption, setAssignOption] = useState();
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [selectedKeyword, setSelectedKeyword] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [infoType, setInfoType] = useState();
  const isMobile = useIsMobile();
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));

  const ALL_STATUS = [
    { value: "11", label: "offen" },
    { value: "20", label: "NICHT ERREICHT" },
    { value: "21", label: "TERMINIERT (1)" },
    { value: "25", label: "TERMINIERT (2)" },
    { value: "26", label: "TERMINIERT (3)" },
    { value: "12", label: "ZEITLICHE VERZÖGERUNG" },
    { value: "12", label: "SPÄTER ANRUFEN" },
    { value: "13", label: "AUFMAß" },
    { value: "14", label: "ANGEBOTSBESPRECHUNG" },
    { value: "15", label: "ANGEBOTSBESPRECHUNG 2" },
    { value: "16", label: "ABSAGE" },
    { value: "17", label: "VERKAUFT" },
    { value: "19", label: "STORNO" },
    { value: "20", label: "Open" },
    { value: "27", label: "Confirmed" },
    { value: "28", label: "Rejected" },
  ];

  const INFO_TYPS_OPTIONS = [{ value: true, label: "nicht angetroffen" }];

  const handleChangeAssign = (data, type) => {
    console.log("🚀 ~ handleChangeAssign ~ type:", type);
    switch (type) {
      case "isAssign":
        setAssignOption(data);
        break;
      case "projectName":
        setSelectedProject(data);
        break;
      case "keyword":
        setSelectedKeyword(data);
        break;
      case "infoType":
        setInfoType(data);
      case "user":
        setUsers(data);
        break;
    }
  };
  const assignLeadOption = [
    {
      value: true,
      label: "zugeteilt",
    },
    {
      value: false,
      label: "nicht zugeteilt",
    },
  ];

  const LeadSourceArray = [
    {
      value: "straper",
      label: "Wattfox",
    },
    {
      value: "vattenfall",
      label: "Vattenfall",
    },
  ];

  const boundedDetails = useMemo(() => {
    return {
      West: bounds?.getSouthWest()?.lng(),
      South: bounds?.getSouthWest()?.lat(),
      East: bounds?.getNorthEast()?.lng(),
      North: bounds?.getNorthEast()?.lat(),
    };
  }, [bounds]);
  const debouncedSearchValue = useDebounce(boundedDetails, 1000);

  const handleGetDashboardCount = async () => {
    const mappedUser = Users?.map((item) => item.value);
    const leadStatusMap = leadStatus?.map((item) => item.label);
    const body = {
      //   isAssign: !!assignOption?.length ? assignOption : [],
      //   projectName: !!selectedProject?.length ? selectedProject : [],
      //   keyword: !!selectedKeyword?.length ? selectedKeyword : [],
      //   infoType: !!infoType?.length ? infoType : [],
      benutzerId: [userInfo?._id],
    };

    let url = `vattenfall/getMultiLocationLead?West=${
      debouncedSearchValue?.West || ""
    }&South=${debouncedSearchValue?.South || ""}&East=${
      debouncedSearchValue?.East || ""
    }&North=${debouncedSearchValue?.North || ""}`;

    if (searchDebaounce) {
      url += `&search=${searchDebaounce}`;
    }

    if (LeadSources) {
      url += `&type=${LeadSources.value}`;
    }

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    if (startDate && endDate) {
      url += `&startDate=${formatDate(startDate)}`;
      url += `&endDate=${formatDate(endDate)}`;
    } else if (startDate || endDate) {
      return;
    }

    if (infoType?.value) {
      url += `&infoType=${infoType.value}`;
    }
    if (isNotNullOrUndefined(assignOption?.value)) {
      url += `&isAssign=${assignOption.value}`;
    }
    if (isNotNullOrUndefined(selectedProject?.value)) {
      url += `&projectName=${selectedProject.value}`;
    }
    if (selectedKeyword?.length) {
      const keyword = selectedKeyword?.map((item) => item.value);
      forEach(keyword, (item) => {
        url += `&keyword[]=${item}`;
      });
    }
    if (Users?.length) {
      const userId = Users?.map((item) => item.value);
      forEach(userId, (item) => {
        url += `&userId[]=${item}`;
      });
    }
    await ApiPost(url, body)
      .then((response) => {
        const data = response?.data?.payload;
        setLeadsData([...data?.vattenfallLead]);
      })
      .catch((error) => {
        toast.error(error.message || "Something went wrong.");
      });
  };

  useEffect(() => {
    if (
      boundedDetails &&
      boundedDetails?.West &&
      boundedDetails?.South &&
      boundedDetails?.East &&
      boundedDetails?.North
    ) {
      handleGetDashboardCount();
    }
  }, [
    debouncedSearchValue,
    searchDebaounce,
    LeadSources,
    assignOption,
    selectedProject,
    selectedKeyword,
    startDate,
    endDate,
    infoType,
    Users,
  ]);

  const getVertisebPartner = async () => {
    try {
      let resp = await ApiGet(`user/get`);

      const data = resp?.data?.payload?.data;
      const mappedData = data?.map((item) => {
        const obj = {
          value: item?._id,
          label: item?.name,
        };
        return obj;
      });
      setAllUser(mappedData);
    } catch (error) {
      console.error("error:", error);
    }
  };

  const getAllKeyWords = async () => {
    try {
      const response = await ApiGet("vattenfall/getKeywordList");
      const data = response?.data?.payload?.keywords?.map((item) => {
        const data = {
          value: item,
          label: item,
        };
        return data;
      });
      setKeywords(data);
    } catch (error) {}
  };

  const handleGetProject = async () => {
    await ApiGet(`project/get`)
      .then((response) => {
        const data = response?.data?.payload.data;
        const optionData = data?.map((item) => ({
          value: item._id,
          label: item.projectname,
        }));
        setProjectOptions(optionData);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    getAllKeyWords();
    getVertisebPartner();
    handleGetProject();
  }, []);

  const newhandleOnNewChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  // const handleChangeAssign = (data) => {
  //   setAssignOption(data);
  // };

  return (
    <>
      <div className={`${isMobile ? "p-3" : "card "} p-0 p-sm-1`}>
        <div className={`p-0 p-sm-2 mb-2 ${isMobile ? "card" : ""}`}>
          <div className="row mb-4 px-3 ">
            <div className="alignment-class">
              <div>
                <h2 className="pt-2 mr-5">Heatmap</h2>
              </div>

              <div className="row  mobile-view-alignment-main">
                <div>
                  <div className="project-Dropdown project-Dropdown-sc">
                    <Select
                      className="Select-main"
                      // menuIsOpen={true}
                      value={assignOption}
                      name="isAssign"
                      onChange={(e) => handleChangeAssign(e, "isAssign")}
                      options={assignLeadOption}
                      styles={ProjectStyle}
                      defaultValue={assignOption}
                      placeholder="zugeteilt"
                      isClearable={true}
                    />
                  </div>
                </div>
                {/* <div>
                  <div className="project-Dropdown project-Dropdown-sc">
                    <Select
                      className="Select-main"
                      // menuIsOpen={true}
                      value={selectedProject}
                      name="projectName"
                      onChange={(e) => handleChangeCommom(e, "projectName")}
                      options={projectOptions}
                      styles={ProjectStyle}
                      defaultValue={selectedProject}
                      placeholder="Projekt "
                      isClearable={true}
                    />
                  </div>
                </div> */}
                <div>
                  <div className="project-Dropdown project-Dropdown-sc">
                    <Select
                      className="Select-main"
                      value={Users}
                      onChange={(e) => handleChangeAssign(e, "user")}
                      options={AllUser}
                      styles={ProjectStyle}
                      placeholder="Vertriebspartner"
                      isMulti={true}
                      isClearable={true}
                    />
                  </div>
                </div>
                <div>
                  <div className="project-Dropdown project-Dropdown-sc">
                    <Select
                      className="dropdown-align "
                      value={selectedKeyword}
                      name="keyword"
                      onChange={(e) => {
                        handleChangeAssign(e, "keyword");
                      }}
                      placeholder="keyword"
                      options={keywords}
                      isMulti
                      maxHeight={"40px"}
                      isClearable={true}
                      styles={ProjectStyle}
                    />
                  </div>
                </div>
                <div className="date-picker">
                  <DatePicker
                    selected={startDate}
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="Date"
                    onChange={(e) => newhandleOnNewChange(e)}
                    onKeyDown={(e) => e.preventDefault()}
                    maxDate={new Date()}
                    selectsRange
                    dateFormat="dd/MM/yyyy"
                    className="custom-date"
                    isClearable
                  />
                </div>

                <div className="date-picker" style={{ marginLeft: "10px" }}>
                  <div>
                    <input
                      type="search"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => {
                        setSearchValue(e.target.value);
                      }}
                      name="Suche"
                      value={searchValue}
                      placeholder="Suche"
                    />
                  </div>
                </div>

                {/* {map && (
                  <div>
                    <GoogleAutocomplete
                      setSearchLat={setSearchLat}
                      map={map}
                      center={center}
                      zoom={zoom}
                      setZoom={setZoom}
                    />
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <div className="dekstop-view-map">
            <MapComponent
              searchLat={searchLat}
              marker={center}
              // center={center}
              center={searchLat?.lat ? searchLat : center}
              setOpenMarker={setOpenMarker}
              openMarker={openMarker}
              setBounds={setBounds}
              setZoom={setZoom}
              leadsData={leadsData}
              zoom={zoom}
              bounds={bounds}
              setMap={setMap}
              map={map}
              handleGetDashboardCount={handleGetDashboardCount}
            />
          </div>
        </div>
      </div>
      <div className="mobile-view-map">
        <MapComponent
          searchLat={searchLat}
          marker={center}
          // center={center}
          center={searchLat?.lat ? searchLat : center}
          setOpenMarker={setOpenMarker}
          openMarker={openMarker}
          setBounds={setBounds}
          setZoom={setZoom}
          leadsData={leadsData}
          zoom={zoom}
          bounds={bounds}
          setMap={setMap}
          map={map}
          handleGetDashboardCount={handleGetDashboardCount}
        />
      </div>
    </>
  );
};

export default GoogleMap;
